// Importing necessary utilities for styling
import {
  defaultFont,
  dangerColor,
  whiteColor,
} from "assets/jss/material-dashboard-react";

// Defining styles for header links
const headerLinksStyle = theme => ({
  // Styles for the search input
  search: {
    "& > div": {
      marginTop: "0", // No top margin for child divs
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 15px !important", // Margin for small screens
      float: "none !important", // Reset float
      paddingTop: "1px", // Padding at the top
      paddingBottom: "1px", // Padding at the bottom
      padding: "0!important", // Reset padding
      width: "60%", // Width for small screens
      marginTop: "40px", // Top margin for small screens
      "& input": {
        color: whiteColor, // Input text color
      },
    },
  },
  // Styles for radio button containers
  radioBox: {
    display: "flex", // Flexbox layout
    flexDirection: "row", // Row layout
    alignItem: "center", // Center alignment
    justifyContent: "center", // Center justification
  },
  // Styles for hiding search on larger screens
  hideSearch: {
    [theme.breakpoints.up("md")]: {
      width: "90%", // Width for medium screens
      display: "flex", // Flexbox layout
      flexDirection: "row", // Row layout
      alignItem: "center", // Center alignment
      justifyContent: "center", // Center justification
    },
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide on small screens
    },
  },
  // Styles for unique radio button containers
  radioBoxUnique: {
    display: "flex", // Flexbox layout
    height: "auto", // Auto height
    flexDirection: "row", // Row layout
    alignItem: "center", // Center alignment
    justifyContent: "center", // Center justification
  },
  // Styles for the root of radio button containers
  radioBoxRoot: {
    display: "flex", // Flexbox layout
    flexDirection: "row", // Row layout
  },
  // General flex display style
  displayFlex: {
    display: "flex", // Flexbox layout
  },
  // Styles for date and terms and conditions text
  datetnc: {
    color: theme.palette.info.main, // Info color
  },
  // Styles for radio button text color
  textColorRadio: {
    color: theme.palette.primary.dark, // Primary dark color
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
    marginTop: ".5rem", // Top margin
  },
  // Styles for radio button text in cards
  textColorRadioCard: {
    color: theme.palette.primary.dark, // Primary dark color
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
  },
  // Styles for "thanks" text
  thanksColor: {
    color: theme.palette.error.main, // Error color
    fontStyle: "italic", // Italic font style
    fontWeight: 900, // Bold font weight
    marginLeft: "100px", // Left margin
  },
  // Styles for line bar in payment section
  lineBarPayment: {
    width: "62%", // Width
    marginLeft: "220px", // Left margin
    border: "1px solid #ededed", // Border style
  },
  // Styles for height
  height: {
    height: "100px", // Fixed height
  },
  // Styles for text details
  textDetails: {
    color: theme.palette.primary.dark, // Primary dark color
    fontSize: "90%", // Font size
    fontStyle: "Helvetica, Arial,sans-serif", // Font style
  },
  // Styles for point text
  pointText: {
    color: theme.palette.primary.contrastText, // Contrast text color
  },
  // Styles for centering content
  contentCenter: {
    display: "flex", // Flexbox layout
    justifyContent: "center", // Center justification
    alignItems: "center", // Center alignment
  },
  // Styles for point text with rupee symbol
  pointTextRupe: {
    color: theme.palette.info.main, // Info color
    marginTop: ".5rem", // Top margin
    fontWeight: "bold", // Bold font weight
    fontSize: "18px", // Font size
  },
  // Styles for link background color
  linkBackgroudColor: {
    backgroundColor: theme.palette.primary.contrastText, // Contrast text color
    height: "60px", // Fixed height
    width: "80%", // Width
    borderRadius: 10, // Rounded corners
    marginBottom: "50px", // Bottom margin
  },
  // Styles for dropdowns in dialog boxes
  dialogBoxDropDown: {
    width: "auto", // Auto width
    overflow: "hidden", // Hide overflow
    marginRight: "2%", // Right margin
    marginLeft: "2%", // Left margin
    fontSize: "14px", // Font size
    boxSizing: "border-box", // Box sizing
    fontFamily: "Roboto\", \"Helvetica\", \"Arial\", sans-serif", // Font family
    fontWeight: "200", // Font weight
    lineHeight: "1.5", // Line height
    "&:hover": {
      backgroundColor: theme.palette.primary.main, // Primary color on hover
      color: theme.palette.primary.contrastText, // Contrast text color on hover
    },
  },
  // Styles for header box
  HeaderBox: {
    display: "flex", // Flexbox layout
    marginLeft: "50px", // Left margin
  },
  // Styles for canvas background
  canvasBackgourd: {
    backgroundColor: theme.palette.primary.contrastText, // Contrast text color
  },
  // Styles for header name text
  headerNameText: {
    color: theme.palette.info.light, // Light info color
    fontStyle: "bold", // Bold font style
    fontSize: 14, // Font size
  },
  // Styles for header name details
  headerNameDetails: {
    color: theme.palette.info.main, // Main info color
    fontStyle: "bold", // Bold font style
    fontSize: 14, // Font size
  },
  // Styles for checkboxes
  checkBox: {
    marginBottom: "100px", // Bottom margin
    "&$checked": {
      color: theme.palette.primary.main, // Primary color when checked
    },
  },
  checked: {},
  // Styles for link text
  linkText: {
    zIndex: "4", // Z-index
    ...defaultFont, // Default font
    fontSize: "14px", // Font size
    margin: "0px", // No margin
  },
  // Styles for button links
  buttonLink: {
    [theme.breakpoints.down("sm")]: {
      display: "flex", // Flexbox layout
      margin: "10px 15px 0", // Margin for small screens
      width: "-webkit-fill-available", // Full width
      "& svg": {
        width: "24px", // SVG width
        height: "30px", // SVG height
        marginRight: "15px", // Right margin
        marginLeft: "-15px", // Left margin
      },
      "& .fab,& .fas,& .far,& .fal,& .material-icons": {
        fontSize: "24px", // Font size
        lineHeight: "30px", // Line height
        width: "24px", // Width
        height: "30px", // Height
        marginRight: "15px", // Right margin
        marginLeft: "-15px", // Left margin
      },
      "& > span": {
        justifyContent: "flex-start", // Align to start
        width: "100%", // Full width
      },
    },
  },
  // Styles for search button
  searchButton: {
    [theme.breakpoints.down("sm")]: {
      top: "-50px !important", // Top position for small screens
      marginRight: "22px", // Right margin
      float: "right", // Float to the right
    },
  },
  // Styles for margin top
  marginTop: {
    marginTop: ".7rem", // Top margin
  },
  // Styles for margin input
  marginInput: {
    zIndex: "4", // Z-index
    margin: "0", // No margin
  },
  // Styles for search icon
  searchIcon: {
    width: "17px", // Width
    zIndex: "4", // Z-index
  },
  // Styles for notifications
  notifications: {
    zIndex: "4", // Z-index
    [theme.breakpoints.up("md")]: {
      position: "absolute", // Absolute positioning
      top: "2px", // Top position
      border: `1px solid ${whiteColor}`, // Border style
      right: "4px", // Right position
      fontSize: "9px", // Font size
      background: dangerColor[0], // Danger color background
      color: whiteColor, // White text color
      minWidth: "16px", // Minimum width
      height: "16px", // Fixed height
      borderRadius: "10px", // Rounded corners
      textAlign: "center", // Centered text
      lineHeight: "16px", // Line height
      verticalAlign: "middle", // Vertical alignment
      display: "block", // Block display
    },
    [theme.breakpoints.down("sm")]: {
      ...defaultFont, // Default font
      fontSize: "14px", // Font size
      marginRight: "8px", // Right margin
    },
  },
  // Styles for manager section
  manager: {
    [theme.breakpoints.down("sm")]: {
      width: "100%", // Full width for small screens
    },
    display: "inline-block", // Inline block display
  },
  // Styles for search wrapper
  searchWrapper: {
    [theme.breakpoints.down("sm")]: {
      width: "-webkit-fill-available", // Full width for small screens
      margin: "10px 15px 0", // Margin
    },
    display: "inline-block", // Inline block display
  },
  tittleColor: {
    backgroundColor: theme.palette.primary.dark,
    display: "flex",
    alighItem: "center",
    justifyContent: "center",
    paddingTop: ".7%",
    height: "2rem",
  },
  tittleTextColor: {
    color: theme.palette.primary.contrastText,
    fontSize: "120%",
    fontStyle: "Helvetica, Arial,sans-serif",
  },
  searchGrid: {
    display: "flex",
    flexDirection: "row",
  },
  autoFill: {
    width: "100%",
  },
  margin: {
    margin: "1%",
    marginTop: "2%",
  },
  marginSendLink: {
    margin: "1%",
    marginTop: "2%",
    marginLeft: "220px",
    width: "70%",
  },
  textColor: {
    color: theme.palette.primary.dark,
    fontSize: "90%",
    fontStyle: "Helvetica, Arial,sans-serif",
  },
  input: {
    width: "80%",
  },
  cardWidth: {
    width: "100%",
  },
  iconBox: {
    backgroundColor: theme.palette.info.contrastText,
  },
  tncBox: {
    height: "40px",
    display: "flex",
    alighItem: "center",
    justifyContent: "center",
    borderColor: "black",
  },
  detailBox: {
    width: "50%",
    height: "70%",
    borderRadius: 10,
    marginLeft: "30%",
    backgroundColor: "#f7c9c6",
    padding: ".9%",
  },
  loanDetailBox: {
    width: "70%",
    height: "70%",
    borderRadius: 10,
    marginLeft: "20%",
    backgroundColor: "#f7c9c6",
    padding: ".9%",
  },
  textName: {
    color: "#fcf2fc",
  },
  loanOffrerBox: {
    width: "30%",
    height: "70%",
    borderRadius: 10,
    marginLeft: "5%",
    backgroundColor: "#f7c9c6",
    padding: ".1%",
  },
  detailsMain: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItem: "center",
  },
  detailsMainLoan: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItem: "center",
    width: "70%",
    marginLeft: "10%",
  },
  detailRoot: {
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
  },
  buttonBox: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alighItem: "center",
    margin: "2rem",
  },
  buttonStyle: {
    backgroundColor: theme.palette.primary.main,
  },
  inputBox: {
    marginTop: "4.5%",
    color: "#bfbdbd",
  },
  searchBox: {
    marginTop: "2.5%",
    color: "#bfbdbd",
  },
  gridBox: {
    display: "flex",
    flexDirection: "row",
  },
  activeInputLableColor: {
    fontSize: "14px",
    fontStyle: "Helvetica, Arial,sans-serif",
    "&.focused": {
      color: theme.palette.primary.main,
    },
  },
  root: {
    width: "30%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  emailRoot: {
    width: "80%",
  },
  rootSelectInput: {
    width: "80%",
    marginBottom: "10%",
    fontSize: "90%",
    fontStyle: "Helvetica, Arial,sans-serif",
  },
  resize: {
    fontSize: "14px",
    fontStyle: "Helvetica, Arial,sans-serif",
    color: theme.palette.primary.dark,
  },
  fullInput: {
    width: "93.2%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  halfInput: {
    width: "87%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  halfInputSingle: {
    width: "500px",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  quaterInput: {
    width: "73%",
    "&.focused": {
      color: theme.palette.primary.main,
      fontSize: "90%",
      fontStyle: "Helvetica, Arial,sans-serif",
    },
  },
  stepRoot: {
    backgroundColor: "transparent",
  },
  stepBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    margin: "1%",
    width: "50%",
    backgroundColor: "black",
  },
  stepNumberBox: {
    backgroundColor: "#a1c5ff",
    width: "2%",
    height: "40%",
  },
  readOnlyInput: {
    backgroundColor: "#f5f5f5",
    fontStyle: "italic",
  },
  payLatterHeading: {
    color: "#a3a3a3",
  },
  payLatterCaption: {
    color: "#a3a3a3",
    marginTop: ".5rem",
    fontSize: 14,
  },
});

export default headerLinksStyle;
